import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { useLibraryStore } from "@/stores/library";
import AdditionalAction from "@/interfaces/AdditionalAction";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdditionalActions',
  props: {
  procedure: { type: Object },
  additionalActions: Array<AdditionalAction>
},
  setup(__props) {

const props = __props

const libraryStore = useLibraryStore();

const callAction = (code :string) => {
  libraryStore.callActionByCode(code, { procedure: props.procedure });
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.additionalActions, (action) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        flat: "",
        color: "primary",
        density: "comfortable",
        onClick: ($event: any) => (callAction(action?.action))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(action?.actionName), 1 /* TEXT */)
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}
}

})